import { render, staticRenderFns } from "./CriarApresentante.vue?vue&type=template&id=f2703848&scoped=true"
import script from "./CriarApresentante.vue?vue&type=script&lang=js"
export * from "./CriarApresentante.vue?vue&type=script&lang=js"
import style0 from "./CriarApresentante.vue?vue&type=style&index=0&id=f2703848&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2703848",
  null
  
)

export default component.exports